import { Map, List } from 'immutable';
import cloneDeep from 'lodash/cloneDeep';

import {
  ADD_POPUP_CONFIG_SUCCESS,
  DELETE_POPUP_CONFIG_SUCCESS,
  FETCH_POPUP_CONFIGS_SUCCESS,
  FETCH_POPUP_CONFIG_SUCCESS,
  FETCH_POPUP_LAYERS_CONFIG_SUCCESS,
  SET_COORDINATES_TO_IDENTIFICATION,
  CLEAR_COORDINATES_TO_IDENTIFICATION,
  EDIT_POPUP_LAYER_CONFIG_SUCCESS,
  ADD_POPUP_LAYER_CONFIG_SUCCESS,
  DELETE_POPUP_LAYER_CONFIG_SUCCESS,
  FETCH_LAYER_ATTRIBUTES_SUCCESS,
  OPEN_INFORMATION_MODAL,
  CLOSE_INFORMATION_MODAL,
  MINIMIZE_INFORMATION_MODAL,
  MAXIMIZE_INFORMATION_MODAL,
  RESET_MINIMIZED_MODAL_INFORMATIONS,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_BEGIN,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_FAILED,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_SUCCESS,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_BEGIN,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_FAILED,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_SUCCESS,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_BEGIN,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_SUCCESS,
  FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_FAILED,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_BEGIN,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_FAILED,
  UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_SUCCESS,
  DESKTOP_ADD_POPUP_CONFIG_SUCCESS,
  DESKTOP_EDIT_POPUP_CONFIG_SUCCESS,
  DESKTOP_DELETE_POPUP_CONFIG_SUCCESS,
  DESKTOP_FETCH_POPUP_CONFIGS_SUCCESS,
  FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_BEGIN,
  FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_SUCCESS,
  FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_FINISH,
  ADD_POPUP_LAYER_ATTRIBUTE_SUCCESS,
  EDIT_POPUP_LAYER_ATTRIBUTE_SUCCESS,
  DELETE_POPUP_LAYER_ATTRIBUTE_SUCCESS,
  UPDATE_POPUP_STRUCTURE,
  CLEAR_POPUP_STRUCTURE,
  SET_POPUP_CARD_LOADING_LAYER_STATUS,
  RESET_POPUP_CARD_LOADING_LAYERS_STATUS,
  SET_POPUP_CARD_TREE,
  ADD_POPUP_LAYER_JOIN_SUCCESS,
  FETCH_POPUP_LAYER_JOINS_SUCCESS,
  DELETE_POPUP_LAYER_JOIN_SUCCESS,
  UPDATE_POPUP_LAYER_JOIN_SUCCESS,
  FETCH_POPUP_LAYER_JOIN_ATTRIBUTES_SUCCESS,
  ADD_POPUP_LAYER_JOIN_ATTRIBUTES_SUCCESS,
  DELETE_POPUP_LAYER_JOIN_ATTRIBUTE_SUCCESS,
  UPDATE_POPUP_LAYER_JOIN_ATTRIBUTE_SUCCESS,
  UPDATE_PLOT_LIST_INFORMATION,
  SET_MULTIPLE_COORDINATES_TO_IDENTIFICATION,
  CLEAR_MULTIPLE_COORDINATES_TO_IDENTIFICATION,
  DOWNLOAD_POPUP_DATA_BEGIN,
  DOWNLOAD_POPUP_DATA_SUCCESS,
  DOWNLOAD_POPUP_DATA_FAILED,
  UPDATE_ROAD_LIST_INFORMATION,
  FETCH_PARCELS_DATA_STARTED,
  FETCH_PARCELS_DATA_SUCCESS,
  FETCH_PARCELS_DATA_FINISHED,
  IS_QUERY_PARAMS_POPUP,
  DOWNLOAD_ATTACHMENTS_DATA_TO_PRINT,
  SET_POPUP_URL,
  SET_IS_PREVIEW_MAPS_ENABLED,
  SET_IS_GENERATING_DATA_TO_PRINT,
  SET_ADD_LAYER_JOINS_DATA_TO_PRINT,
  SET_IDENTIFICATION_REQUEST_PARAMS,
  CLEAR_IDENTIFICATION_REQUEST_PARAMS
} from '../constants/popupActionTypes';

const initialState = Map({
  configs: Map({}),
  layersConfigs: List([]),
  coordinatesToIdentification: Map({}),
  attachments: Map({}),
  layerAttributes: Map({}),
  isOpenInformationModal: false,
  isInformationModalMinimized: false,
  minimizedModalPanelName: '',
  minimizedCoordinatesToIdentification: Map({}),
  minimizedPlotsListToIdentification: List([]),
  defaultAttachmentsAttributes: Map({}),
  isFetchingDefaultAttachmentsAttributes: false,
  isFetchedDefaultAttachmentsAttributes: false,
  isUpdateingDefaultAttachmentsAttributes: false,
  isUpdatedDefaultAttachmentsAttributes: false,
  defaultAttachmentsAttributesComposition: Map({}),
  existsDefaultAttributesComposition: false,
  layersDefaultAttributes: Map(),
  popupStructure: List(),
  popupCardTree: List(),
  printCardLoadingLayerStatuses: List(),
  joinsAttributes: Map({}),
  plotListInformation: List([]),
  multipleCoordinatesToIdentification: List([]),
  isDownloadingPopupData: false,
  roadListInformation: List([]),
  isFetchingParcelsData: false,
  parcelsData: List([]),
  isQueryStringPopup: false,
  downloadAttachmentsToPrint: false,
  popupUrl: '',
  isPreviewMapsEnabled: false,
  isGeneratingDataToPrint: false,
  addLayerJoinsToPrint: false,
  isFetchingPopupLayerDefaultAttributes: false,
  requestParams: null,
  savedZoom: null
});

const addPopupConfigSuccess = (state, action) =>
  state.setIn(['configs', String(action.config.id)], action.config);

const deletePopupConfigSuccess = (state, action) =>
  state.deleteIn(['configs', String(action.configId)]);

const fetchPopupConfigsSuccess = (state, action) => {
  const configs = {};

  action.configs.forEach(config => {
    configs[String(config.id)] = config;
  });

  return state.set('configs', Map(configs));
};

const fetchPopupConfigSuccess = (state, action) =>
  state.setIn(['configs', String(action.config.id)], action.config);

const fetchPopupLayersConfigsSuccess = (state, action) =>
  state.merge({
    layersConfigs: List(action.layersConfigs)
  });

const addPopupLayerConfigSuccess = (state, action) => {
  const compositionConfig = state.getIn([
    'configs',
    String(action.layerConfig.config)
  ]);

  const newCompositionConfig = {
    ...compositionConfig,
    composition_configs: [
      ...compositionConfig.composition_configs,
      {
        id: action.layerConfig.id,
        displayable_name: action.layerConfig.displayable_name,
        content_type_id: action.layerConfig.content_type,
        index: 0
      }
    ]
  };

  return state.setIn(
    ['configs', String(action.layerConfig.config)],
    newCompositionConfig
  );
};

const editPopupLayerConfigSuccess = (state, action) =>
  state.update('layersConfigs', List(), list => {
    const newList = [...list];
    const editedLayerConfigIndex = newList.findIndex(
      config => config.id === action.layerConfig.id
    );
    newList[editedLayerConfigIndex] = action.layerConfig;
    return List(newList);
  });

const deletePopupLayerConfigSuccess = (state, action) => {
  const compositionConfig = {
    ...state.getIn(['configs', String(action.configId)])
  };

  const newConfigs = compositionConfig.composition_configs?.filter(
    ({ id }) => id !== action.layerConfigId
  );
  compositionConfig.composition_configs = newConfigs;

  return state.setIn(['configs', String(action.configId)], compositionConfig);
};

const setCoordinatesToIdentification = (state, { lat, lng }) =>
  state.merge({
    coordinatesToIdentification: Map({
      lat,
      lng
    })
  });

const clearCoordinatesToIdentification = state =>
  state.merge({
    coordinatesToIdentification: Map({})
  });

const setMultipleCoordinatesToIdentification = (state, action) =>
  state.merge({
    multipleCoordinatesToIdentification: List(
      action.multipleCoordinatesToIdentification
    )
  });

const clearMultipleCoordinatesToIdentification = state =>
  state.merge({
    multipleCoordinatesToIdentification: List([])
  });

const fetchLayerAttrbutesSuccess = (state, action) =>
  state.mergeDeep(
    Map({
      layerAttributes: Map({
        ...state.get('layerAttributes'),
        [action.modelId]: action.layerAttributes
      })
    })
  );

const openInformationModal = state =>
  state.merge(
    Map({
      isOpenInformationModal: true,
      isInformationModalMinimized: false,
      minimizedModalPanelName: ''
    })
  );

const closeInformationModal = state =>
  state.merge(
    Map({
      isOpenInformationModal: false,
      minimizedModalPanelName: ''
    })
  );

const minimizeInformationModal = (
  state,
  { panelName, coordinatesToIdentification, plotsListToIdentification }
) =>
  state.merge(
    Map({
      isInformationModalMinimized: true,
      minimizedModalPanelName: panelName,
      minimizedCoordinatesToIdentification: coordinatesToIdentification,
      minimizedPlotsListToIdentification: plotsListToIdentification
    })
  );

const maximizeInformationModal = state =>
  state.merge(
    Map({
      isInformationModalMinimized: false,
      minimizedModalPanelName: ''
    })
  );

const resetMinimizedModalInformations = state =>
  state.merge(
    Map({
      isInformationModalMinimized: false,
      minimizedModalPanelName: '',
      minimizedCoordinatesToIdentification: Map({}),
      minimizedPlotsListToIdentification: List([])
    })
  );

const fetchDefaultAttachmentsAttributesBegin = state =>
  state.merge({
    isFetchingDefaultAttachmentsAttributes: true,
    isFetchedDefaultAttachmentsAttributes: false,
    defaultAttachmentsAttributes: Map({})
  });

const fetchDefaultAttachmentsAttributesSuccess = (state, action) =>
  state.merge({
    isFetchingDefaultAttachmentsAttributes: false,
    isFetchedDefaultAttachmentsAttributes: true,
    defaultAttachmentsAttributes: Map(action.default)
  });

const fetchDefaultAttachmentsAttributesFailed = state =>
  state.merge({
    isFetchingDefaultAttachmentsAttributes: false,
    isFetchedDefaultAttachmentsAttributes: false,
    defaultAttachmentsAttributes: Map({})
  });

const fetchDefaultAttachmentsAttributesCompositionBegin = state =>
  state.merge({
    isFetchingDefaultAttachmentsAttributesComposition: true,
    isFetchedDefaultAttachmentsAttributesComposition: false,
    defaultAttachmentsAttributesComposition: Map({})
  });

const fetchDefaultAttachmentsAttributesCompositionSuccess = (state, action) =>
  state.merge({
    isFetchingDefaultAttachmentsAttributesComposition: false,
    isFetchedDefaultAttachmentsAttributesComposition: true,
    defaultAttachmentsAttributesComposition: Map(action.default),
    existsDefaultAttributesComposition: action.exists
  });

const fetchDefaultAttachmentsAttributesCompositionFailed = state =>
  state.merge({
    isFetchingDefaultAttachmentsAttributesComposition: false,
    isFetchedDefaultAttachmentsAttributesComposition: false,
    defaultAttachmentsAttributesComposition: Map({})
  });

const updateDefaultAttachmentsAttributesBegin = state =>
  state.merge({
    isUpdatedDefaultAttachmentsAttributes: true,
    isUpdateingDefaultAttachmentsAttributes: false
  });

const updateDefaultAttachmentsAttributesSuccess = (state, { attributes }) =>
  state.merge({
    isUpdateingDefaultAttachmentsAttributes: false,
    isUpdatedDefaultAttachmentsAttributes: true,
    defaultAttachmentsAttributes: Map(attributes)
  });

const updateDefaultAttachmentsAttributesFailed = state =>
  state.merge({
    isUpdateingDefaultAttachmentsAttributes: false,
    isUpdatedDefaultAttachmentsAttributes: false
  });

const updateDefaultAttachmentsAttributesCompositionBegin = state =>
  state.merge({
    isUpdatedDefaultAttachmentsAttributesComposition: true,
    isUpdateingDefaultAttachmentsAttributesComposition: false
  });

const updateDefaultAttachmentsAttributesCompositionSuccess = (
  state,
  { attributes }
) =>
  state.merge({
    isUpdateingDefaultAttachmentsAttributesComposition: false,
    isUpdatedDefaultAttachmentsAttributesComposition: true,
    existsDefaultAttributesComposition: true,
    defaultAttachmentsAttributesComposition: attributes
  });

const updateDefaultAttachmentsAttributesCompositionFailed = state =>
  state.merge({
    isUpdateingDefaultAttachmentsAttributesComposition: false,
    isUpdatedDefaultAttachmentsAttributesComposition: false
  });

const desktopAddPopupConfigSuccess = (
  state,
  { district, mapPortalCompositionId, config, isExternalLayer, sourceType }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const configs = state.getIn(path, List());

  const newConfig = {
    ...config,
    newLayer: { is_external_layer: isExternalLayer, source_type: sourceType }
  };

  const nextConfigs = configs.push(newConfig);
  return state.setIn(path, nextConfigs);
};

const desktopEditPopupConfigSuccess = (
  state,
  { district, mapPortalCompositionId, config }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const configs = state.getIn(path);
  const configIndex = configs.findIndex(({ id }) => id === config.id);
  return state.setIn([...path, configIndex], config);
};

const desktopDeletePopupConfigSuccess = (
  state,
  { district, mapPortalCompositionId, configId }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const configs = state.getIn(path);
  const configIndex = configs.findIndex(({ id }) => id === configId);
  const nextConfigs = configs.delete(configIndex);
  return state.setIn(path, nextConfigs);
};

const desktopFetchPopupConfigsBegin = state =>
  state.set('isFetchingPopupLayerDefaultAttributes', true);

const desktopFetchPopupConfigsSuccess = (
  state,
  { district, mapPortalCompositionId, configs }
) => state.setIn(['configs', district, mapPortalCompositionId], List(configs));

const desktopFetchPopupConfigsFinish = state =>
  state.set('isFetchingPopupLayerDefaultAttributes', false);

const fetchPopupLayerDefaultAttributesSuccess = (
  state,
  { layerId, attributes }
) => state.setIn(['layersDefaultAttributes', layerId], List(attributes));

const addPopupLayerAttributeSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, attribute }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const layerConfigs = state.getIn(path);
  const layerConfigIndex = layerConfigs?.findIndex(
    item => item.id === layerConfigId
  );
  const layerConfig = layerConfigs.get(layerConfigIndex);

  const newLayerConfig = cloneDeep(layerConfig);
  newLayerConfig.attributes.unshift(attribute);

  return state.setIn([...path, layerConfigIndex], newLayerConfig);
};

const editPopupLayerAttributeSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, attribute }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const layerConfigs = state.getIn(path);
  const layerConfigIndex = layerConfigs?.findIndex(
    item => item.id === layerConfigId
  );
  const layerConfig = layerConfigs.get(layerConfigIndex);

  const newLayerConfig = cloneDeep(layerConfig);
  const attributeToEditIndex = newLayerConfig.attributes.findIndex(
    ({ id }) => id === attribute.id
  );
  newLayerConfig.attributes[attributeToEditIndex] = attribute;

  return state.setIn([...path, layerConfigIndex], newLayerConfig);
};

const deletePopupLayerAttributeSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, attributeId }
) => {
  const path = ['configs', district, mapPortalCompositionId];
  const layerConfigs = state.getIn(path);
  const layerConfigIndex = layerConfigs?.findIndex(
    item => item.id === layerConfigId
  );
  const layerConfig = layerConfigs.get(layerConfigIndex);

  const newLayerConfig = cloneDeep(layerConfig);
  newLayerConfig.attributes = newLayerConfig.attributes.filter(
    ({ id }) => id !== attributeId
  );

  return state.setIn([...path, layerConfigIndex], newLayerConfig);
};

const updateLayersStructure = (state, { layers }) =>
  state.set('popupStructure', List(layers));

const clearPopupStructure = state => state.set('popupStructure', List());

const setPopupCardTree = (state, { tree }) =>
  state.set('popupCardTree', List(tree));

const setPopupCardLayerLoadingStatus = (state, action) => {
  let statuses = state.get('printCardLoadingLayerStatuses');
  const statusIndex = statuses.findIndex(({ id }) => id === action.id);
  const loadingStatus = { id: action.id, isLoading: action.status };
  const currentStatus = statuses.get(statusIndex);

  if (currentStatus?.isLoading === action.status) {
    return state;
  }

  if (statusIndex === -1) {
    statuses = statuses.push(loadingStatus);
  } else {
    statuses = statuses.set(statusIndex, loadingStatus);
  }

  return state.set('printCardLoadingLayerStatuses', statuses);
};

const resetPopupCardLayersLoadingStatus = state => {
  const statuses = state.get('printCardLoadingLayerStatuses');

  const statusesWithDisabledLoading = statuses.map(status => ({
    ...status,
    isLoading: false
  }));

  return state.set(
    'printCardLoadingLayerStatuses',
    statusesWithDisabledLoading
  );
};

const addPopupLayerJoinSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, join }
) => {
  const layerJoins = state.getIn([
    'joins',
    district,
    mapPortalCompositionId,
    layerConfigId
  ]);

  const newLayerJoins = [...layerJoins, join];

  return state.setIn(
    ['joins', district, mapPortalCompositionId, layerConfigId],
    newLayerJoins
  );
};

const fetchPopupLayerJoinsSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joins }
) =>
  state.setIn(
    ['joins', district, mapPortalCompositionId, layerConfigId],
    joins
  );

const deletePopupLayerJoinsSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joinId }
) => {
  const layerJoins = state.getIn([
    'joins',
    district,
    mapPortalCompositionId,
    layerConfigId
  ]);

  const nextJoins = layerJoins.filter(({ id }) => id !== joinId);

  return state.setIn(
    ['joins', district, mapPortalCompositionId, layerConfigId],
    nextJoins
  );
};

const updatePopupLayerJoinsSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joinId, join }
) => {
  const layerJoins = state.getIn([
    'joins',
    district,
    mapPortalCompositionId,
    layerConfigId
  ]);

  const nextJoins = [...layerJoins.filter(({ id }) => id !== joinId), join];

  return state.setIn(
    ['joins', district, mapPortalCompositionId, layerConfigId],
    nextJoins
  );
};

const fetchPopupLayerJoinAttributesSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joinId, joinAttributes }
) =>
  state.setIn(
    [
      'joinsAttributes',
      district,
      mapPortalCompositionId,
      layerConfigId,
      joinId
    ],
    joinAttributes
  );

const addPopupLayerJoinAttributesSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joinId, attribute }
) => {
  const layerJoinAttributes = state.getIn([
    'joinsAttributes',
    district,
    mapPortalCompositionId,
    layerConfigId,
    joinId
  ]);

  const newLayerJoinAttributes = [...layerJoinAttributes, attribute];

  return state.setIn(
    [
      'joinsAttributes',
      district,
      mapPortalCompositionId,
      layerConfigId,
      joinId
    ],
    newLayerJoinAttributes
  );
};

const deletePopupLayerJoinAttributesSuccess = (
  state,
  { district, mapPortalCompositionId, layerConfigId, joinId, attributeId }
) => {
  const layerJoinAttributes = state.getIn([
    'joinsAttributes',
    district,
    mapPortalCompositionId,
    layerConfigId,
    joinId
  ]);

  const newLayerJoinAttributes = layerJoinAttributes.filter(
    ({ id }) => id !== attributeId
  );

  return state.setIn(
    [
      'joinsAttributes',
      district,
      mapPortalCompositionId,
      layerConfigId,
      joinId
    ],
    newLayerJoinAttributes
  );
};

const updatePopupLayerJoinAttributeSuccess = (
  state,
  {
    district,
    mapPortalCompositionId,
    layerConfigId,
    joinId,
    attributeId,
    attribute
  }
) => {
  const layerJoinAttributes = state.getIn([
    'joinsAttributes',
    district,
    mapPortalCompositionId,
    layerConfigId,
    joinId
  ]);

  const nextLayerJoinAttributes = [
    ...layerJoinAttributes.filter(({ id }) => id !== attributeId),
    attribute
  ];

  return state.setIn(
    [
      'joinsAttributes',
      district,
      mapPortalCompositionId,
      layerConfigId,
      joinId
    ],
    nextLayerJoinAttributes
  );
};

const updatePlotListInformation = (state, { plotListInformation }) =>
  state.set('plotListInformation', List(plotListInformation));

const setPopupDataDownloading = state =>
  state.set('isDownloadingPopupData', true);

const unsetPopupDataDownloading = state =>
  state.set('isDownloadingPopupData', false);

const updateRoadListInformation = (state, action) =>
  state.set('roadListInformation', List(action.roadListInformation));

const setFetchParcelsDataStarted = state =>
  state.set('isFetchingParcelsData', true);

const setFetchParcelsDataSuccess = (state, { parcelsData }) =>
  state.merge({
    isFetchingParcelsData: false,
    parcelsData: List(parcelsData)
  });

const setFetchParcelsDataFinished = state =>
  state.set('isFetchingParcelsData', false);

const setIsQueryStringPopup = (state, { isQueryStringPopup }) =>
  state.set('isQueryStringPopup', isQueryStringPopup);

const setDownladAttachmentsDataToPrint = (state, { downloadAttachments }) =>
  state.set('downloadAttachmentsToPrint', downloadAttachments);

const setPopupUrl = (state, { url }) => state.set('popupUrl', url);

const setIsPreviewMapsEnabled = (state, { value }) =>
  state.set('isPreviewMapsEnabled', value);

const setIsGeneratingDataToPrint = (state, { value }) =>
  state.set('isGeneratingDataToPrint', value);

const setAddLayerJoinsDataToPrint = (state, { value }) =>
  state.set('addLayerJoinsToPrint', value);

const setIdentificationRequestParams = (state, { requestParams, zoom }) =>
  state.merge({
    requestParams,
    savedZoom: zoom
  });

const clearIdentificationRequestParams = state =>
  state.merge({
    requestParams: null,
    savedZoom: null
  });

export default function reducer(state = initialState, action) {
  return (
    {
      [ADD_POPUP_CONFIG_SUCCESS]: addPopupConfigSuccess,
      [DELETE_POPUP_CONFIG_SUCCESS]: deletePopupConfigSuccess,
      [FETCH_POPUP_CONFIGS_SUCCESS]: fetchPopupConfigsSuccess,
      [FETCH_POPUP_CONFIG_SUCCESS]: fetchPopupConfigSuccess,
      [FETCH_POPUP_LAYERS_CONFIG_SUCCESS]: fetchPopupLayersConfigsSuccess,
      [ADD_POPUP_LAYER_CONFIG_SUCCESS]: addPopupLayerConfigSuccess,
      [EDIT_POPUP_LAYER_CONFIG_SUCCESS]: editPopupLayerConfigSuccess,
      [DELETE_POPUP_LAYER_CONFIG_SUCCESS]: deletePopupLayerConfigSuccess,
      [SET_COORDINATES_TO_IDENTIFICATION]: setCoordinatesToIdentification,
      [CLEAR_COORDINATES_TO_IDENTIFICATION]: clearCoordinatesToIdentification,
      [FETCH_LAYER_ATTRIBUTES_SUCCESS]: fetchLayerAttrbutesSuccess,
      [OPEN_INFORMATION_MODAL]: openInformationModal,
      [CLOSE_INFORMATION_MODAL]: closeInformationModal,
      [MINIMIZE_INFORMATION_MODAL]: minimizeInformationModal,
      [MAXIMIZE_INFORMATION_MODAL]: maximizeInformationModal,
      [RESET_MINIMIZED_MODAL_INFORMATIONS]: resetMinimizedModalInformations,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_BEGIN]: fetchDefaultAttachmentsAttributesBegin,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_SUCCESS]: fetchDefaultAttachmentsAttributesSuccess,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_FAILED]: fetchDefaultAttachmentsAttributesFailed,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_BEGIN]: fetchDefaultAttachmentsAttributesCompositionBegin,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_SUCCESS]: fetchDefaultAttachmentsAttributesCompositionSuccess,
      [FETCH_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_FAILED]: fetchDefaultAttachmentsAttributesCompositionFailed,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_BEGIN]: updateDefaultAttachmentsAttributesBegin,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_SUCCESS]: updateDefaultAttachmentsAttributesSuccess,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_FAILED]: updateDefaultAttachmentsAttributesFailed,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_BEGIN]: updateDefaultAttachmentsAttributesCompositionBegin,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_SUCCESS]: updateDefaultAttachmentsAttributesCompositionSuccess,
      [UPDATE_DEFAULT_ATTACHMENTS_ATTRIBUTES_COMPOSITION_FAILED]: updateDefaultAttachmentsAttributesCompositionFailed,
      [DESKTOP_ADD_POPUP_CONFIG_SUCCESS]: desktopAddPopupConfigSuccess,
      [DESKTOP_EDIT_POPUP_CONFIG_SUCCESS]: desktopEditPopupConfigSuccess,
      [DESKTOP_DELETE_POPUP_CONFIG_SUCCESS]: desktopDeletePopupConfigSuccess,
      [DESKTOP_FETCH_POPUP_CONFIGS_SUCCESS]: desktopFetchPopupConfigsSuccess,
      [FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_BEGIN]: desktopFetchPopupConfigsBegin,
      [FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_SUCCESS]: fetchPopupLayerDefaultAttributesSuccess,
      [FETCH_POPUP_LAYER_DEFAULT_ATTRIBUTES_FINISH]: desktopFetchPopupConfigsFinish,
      [ADD_POPUP_LAYER_ATTRIBUTE_SUCCESS]: addPopupLayerAttributeSuccess,
      [EDIT_POPUP_LAYER_ATTRIBUTE_SUCCESS]: editPopupLayerAttributeSuccess,
      [DELETE_POPUP_LAYER_ATTRIBUTE_SUCCESS]: deletePopupLayerAttributeSuccess,
      [UPDATE_POPUP_STRUCTURE]: updateLayersStructure,
      [CLEAR_POPUP_STRUCTURE]: clearPopupStructure,
      [SET_POPUP_CARD_TREE]: setPopupCardTree,
      [SET_POPUP_CARD_LOADING_LAYER_STATUS]: setPopupCardLayerLoadingStatus,
      [RESET_POPUP_CARD_LOADING_LAYERS_STATUS]: resetPopupCardLayersLoadingStatus,
      [ADD_POPUP_LAYER_JOIN_SUCCESS]: addPopupLayerJoinSuccess,
      [FETCH_POPUP_LAYER_JOINS_SUCCESS]: fetchPopupLayerJoinsSuccess,
      [DELETE_POPUP_LAYER_JOIN_SUCCESS]: deletePopupLayerJoinsSuccess,
      [UPDATE_POPUP_LAYER_JOIN_SUCCESS]: updatePopupLayerJoinsSuccess,
      [FETCH_POPUP_LAYER_JOIN_ATTRIBUTES_SUCCESS]: fetchPopupLayerJoinAttributesSuccess,
      [ADD_POPUP_LAYER_JOIN_ATTRIBUTES_SUCCESS]: addPopupLayerJoinAttributesSuccess,
      [DELETE_POPUP_LAYER_JOIN_ATTRIBUTE_SUCCESS]: deletePopupLayerJoinAttributesSuccess,
      [UPDATE_POPUP_LAYER_JOIN_ATTRIBUTE_SUCCESS]: updatePopupLayerJoinAttributeSuccess,
      [UPDATE_PLOT_LIST_INFORMATION]: updatePlotListInformation,
      [SET_MULTIPLE_COORDINATES_TO_IDENTIFICATION]: setMultipleCoordinatesToIdentification,
      [CLEAR_MULTIPLE_COORDINATES_TO_IDENTIFICATION]: clearMultipleCoordinatesToIdentification,
      [DOWNLOAD_POPUP_DATA_BEGIN]: setPopupDataDownloading,
      [DOWNLOAD_POPUP_DATA_SUCCESS]: unsetPopupDataDownloading,
      [DOWNLOAD_POPUP_DATA_FAILED]: unsetPopupDataDownloading,
      [UPDATE_ROAD_LIST_INFORMATION]: updateRoadListInformation,
      [FETCH_PARCELS_DATA_STARTED]: setFetchParcelsDataStarted,
      [FETCH_PARCELS_DATA_SUCCESS]: setFetchParcelsDataSuccess,
      [FETCH_PARCELS_DATA_FINISHED]: setFetchParcelsDataFinished,
      [IS_QUERY_PARAMS_POPUP]: setIsQueryStringPopup,
      [DOWNLOAD_ATTACHMENTS_DATA_TO_PRINT]: setDownladAttachmentsDataToPrint,
      [SET_POPUP_URL]: setPopupUrl,
      [SET_IS_PREVIEW_MAPS_ENABLED]: setIsPreviewMapsEnabled,
      [SET_IS_GENERATING_DATA_TO_PRINT]: setIsGeneratingDataToPrint,
      [SET_ADD_LAYER_JOINS_DATA_TO_PRINT]: setAddLayerJoinsDataToPrint,
      [SET_IDENTIFICATION_REQUEST_PARAMS]: setIdentificationRequestParams,
      [CLEAR_IDENTIFICATION_REQUEST_PARAMS]: clearIdentificationRequestParams
    }[action.type] || (s => s)
  )(state, action);
}
